import { DataModelAttributeType } from '@flowx/designer/modules/core/dictionary/data-model.dictionary'

// The backend requires certain attribute types to carry properties (e.g. FLOAT needs
// `numberOfDecimals`). `withDefaults` fills those in at the single point every bulk path-attribute
// call passes through, so no caller (any AI agent or flow) can send a payload that 500s. An existing
// value (e.g. agent-provided) is always kept.
export const DEFAULT_FLOAT_DECIMALS = 2

type BulkAttributeLike = {
  type?: DataModelAttributeType
  properties?: Record<string, unknown> | null
}

// Fill in the backend-required defaults for a single attribute. Add a `case` per type that needs them.
const withAttributeDefaults = (attribute: BulkAttributeLike): BulkAttributeLike => {
  switch (attribute.type) {
    case DataModelAttributeType.FLOAT:
      return {
        ...attribute,
        properties: {
          ...attribute.properties,
          numberOfDecimals:
            (attribute.properties?.['numberOfDecimals'] as number | undefined) ??
            DEFAULT_FLOAT_DECIMALS,
        },
      }
    default:
      return attribute
  }
}

export const withDefaults = (attributes: BulkAttributeLike[]): BulkAttributeLike[] =>
  attributes.map(withAttributeDefaults)
